<template>
  <PageWrapper
    :active-page="PAGE_CREATOR_DASHBOARD"
    :active-section="SECTION_HOME"
    align="left"
    width="full"
  >
    <iRow wrap="nowrap">
      <FeedSideBar />
      <iColumn>
        <iColumn gap="small">
          <iHeading>Dashboard</iHeading>
          <iText font-weight="light" font-size="small">
            Welcome back, {{ userData.first_name }}!
          </iText>
        </iColumn>
        <iSpace />
        <iColumn gap="gigantic" align="left">
          <ProfileChecklist />
          <ExpertiseChecklist />
          <PackagesChecklist />
          <LaunchSiteChecklist />
          <CollaborationChecklist />
          <AdvertiseChecklist />
        </iColumn>
      </iColumn>
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_CREATOR_DASHBOARD, SECTION_HOME } from "@/constants/nav-constants";
import { useGeneralStore } from "%/stores/general-store";
import { mapState } from "pinia";
import LaunchSiteChecklist from "@/components/onboarding/LaunchSiteChecklist.vue";
import CollaborationChecklist from "@/components/onboarding/CollaborationChecklist.vue";
import ExpertiseChecklist from "@/components/onboarding/ExpertiseChecklist.vue";
import AdvertiseChecklist from "@/components/onboarding/AdvertiseChecklist.vue";
import PackagesChecklist from "@/components/onboarding/PackagesChecklist.vue";
import ProfileChecklist from "@/components/onboarding/ProfileChecklist.vue";
import FeedSideBar from "@/components/FeedSideBar.vue";

export default {
  name: "CreatorDashboard",
  components: {
    FeedSideBar,
    ProfileChecklist,
    PackagesChecklist,
    AdvertiseChecklist,
    ExpertiseChecklist,
    CollaborationChecklist,
    LaunchSiteChecklist,
    PageWrapper,
  },
  data() {
    return {
      SECTION_HOME,
      PAGE_CREATOR_DASHBOARD,
    };
  },
  computed: {
    ...mapState(useGeneralStore, [
      "userData",
    ]),
  },
};
</script>

<style scoped lang="scss">

</style>
